import { NgModule } from "@angular/core";
import { CommonModule } from '@angular/common';
import { RouterModule } from "@angular/router";
import { FormsModule } from '@angular/forms';
import { SharedModule } from "../../../core/modules/shared.module";
import { MaterialModule } from './../../../core/modules/material.module';
import { RangeSliderModule } from './../range-slider/range-slider.module';

import { FiltersComponent } from "./filters.component";
import { FiltersService } from './filters.service';

@NgModule({
  imports: [CommonModule, SharedModule, RangeSliderModule, FormsModule, MaterialModule, RouterModule],
  declarations: [FiltersComponent],
  exports: [FiltersComponent],
  providers: [FiltersService]
})
export class FiltersModule {}



// WEBPACK FOOTER //
// ./src/app/main/content/filters/filters.module.ts